export const PATH_TO_HOME = "/";
export const PATH_TO_LOGIN_CALLBACK = "/login/callback";
export const PATH_TO_EDIT_PROFILE = "/edit-profile";
export const PATH_TO_MFA = "/mfa";
export const PATH_TO_CHANGE_PASSWORD = "/change-password";

export const PATH_TO_REGISTER_PARENT = "/join";
export const PATH_TO_REGISTER = "/register";
export const PATH_TO_RECOVER_USERNAME = "/recover-username";
